import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import Page from 'components/widgets/Route';
import * as actions from './actions';
import APIsContainer from './container/APIsContainer';
import EndpointsContainer from './container/EndpointsContainer';

class APIsRoute extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.fetchGroupSummariesData = this.fetchGroupSummariesData.bind(this);
		this.fetchApiDoc = this.fetchApiDoc.bind(this);
	}

	fetchGroupSummariesData() {
		this.props.actions.importApiCancel();
		this.props.actions.fetchApiSpecTypes();
		this.props.actions.fetchGroupSummaries();
	}

	fetchApiDoc({ match: { params: { id } } }) {
		this.props.actions.fetchEndpoint(id);
		this.props.actions.fetchApiSpecTypes();
	}

	render () {
		const { match: { path } } = this.props;
		return (
			<Page>
				<Page.Route
					exact
					path={path}
					onEnter={this.fetchGroupSummariesData}
					component={APIsContainer}
				/>
				<Page.Route
					path={`${path}/:id`}
					onEnter={this.fetchApiDoc}
					component={EndpointsContainer}
				/>
			</Page>
		);
	}
}

APIsRoute.propTypes = {
	match: PropTypes.shape({
		path: PropTypes.string.isRequired
	}).isRequired
};

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

export default compose(
	connect(
		null,
		mapDispatchToProps
	),
	injectIntl,
)(APIsRoute);
